/** Tracking / shell params stripped from canonical URLs. */
export const NON_CANONICAL_QUERY_PARAMS = [
  'ref',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'fbclid',
  'gclid',
  'view',
  'carshow',
  'display',
  'shell',
  'native',
] as const;

/**
 * Build a clean canonical URL from path + optional origin.
 * Strips tracking and shell query params by default.
 */
export function buildCanonicalUrl(
  path: string,
  options?: { origin?: string; keepParams?: string[] }
): string {
  const origin = options?.origin ?? (typeof window !== 'undefined' ? window.location.origin : 'https://biltspec.com');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const base = `${origin}${normalizedPath}`;

  if (typeof window === 'undefined') {
    return base;
  }

  const url = new URL(window.location.href);
  const keep = new Set(options?.keepParams ?? []);
  const params = new URLSearchParams();
  url.searchParams.forEach((value, key) => {
    if (keep.has(key) || !NON_CANONICAL_QUERY_PARAMS.includes(key as (typeof NON_CANONICAL_QUERY_PARAMS)[number])) {
      // Preserve meaningful filter params only when explicitly kept
      if (keep.has(key)) {
        params.set(key, value);
      }
    }
  });

  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

export function absolutizeUrl(url: string, origin?: string): string {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  const base = origin ?? (typeof window !== 'undefined' ? window.location.origin : 'https://biltspec.com');
  return `${base}${url.startsWith('/') ? url : `/${url}`}`;
}
